import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { ListCompanyBilling } from './types/list-company-billing.type';
import type { MergePurgeParameters } from './types/merge-purge-parameters.type';

/**
 * Fetches the billing information for companies associated with a merge-purge report.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - Parameters to filter or specify the merge-purge report.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link ListCompanyBilling}.
 * @throws Throws an error if the request fails.
 */
export const getListCompanyBilling = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<ListCompanyBilling[]>>(Uri.reports.mergePurge.listCompanyBilling, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
